import { makeVar } from "@apollo/client";

import { Gate, PageContent } from "apollo/graphql.generated";
import { defaultPageTheme } from "styles/theme";
import { mapPageThemeToStateTheme } from "styles/theme/themeForPage";

export type PageSection = {
  content: PageContent;
};

export const BALANCE_CONTRACTS = ["ERC20", "native"];
export type GateType = "contract" | "native";

export type Theme = {
  backgroundType: string;
  backgroundColor: string;
  backgroundBottomColor?: string | null;
  textColor: string;
  titleFont: string;
  bodyFont: string;
  cornerShape: string;
};

export type Page = {
  id?: string;
  name: string | null;
  slug: string | null;
  sections: PageSection[];
  gate?: Gate | null;
  gateId?: string | undefined;
  theme: Theme;
};

const defaultTheme = mapPageThemeToStateTheme(defaultPageTheme);

const emptyPage: Page = {
  sections: [],
  theme: defaultTheme,
  name: "",
  slug: "",
};

export const pageVar = makeVar<Page>(emptyPage);

//TODO: When we have more sections we'll need ways to identify and update them.
export const setContent = (content: string) => {
  pageVar({
    ...pageVar(),
    sections: [
      {
        ...pageVar().sections[0],
        content: { editorContent: { state: content } },
      },
    ],
  });
};

export const getContent = () => {
  const section = pageVar().sections[0];
  return section ? section.content : undefined;
};

export const setGate = (gate: Gate | null) => {
  pageVar({
    ...pageVar(),
    gate,
  });
};

export const setGateId = (gateId: string) => {
  pageVar({
    ...pageVar(),
    gateId,
  });
};

export const setTheme = (theme: Theme) => {
  pageVar({
    ...pageVar(),
    theme,
  });
};

export const setPageName = (name: string | null) =>
  pageVar({
    ...pageVar(),
    name,
  });

export const setPageSlug = (slug: string | null) =>
  pageVar({
    ...pageVar(),
    slug,
  });

export const clearPage = () => {
  pageVar(emptyPage);
};

export const filesForUploadVar = makeVar<File[]>([]);

export const addToFilesForUpload = (file: File) =>
  filesForUploadVar([...filesForUploadVar(), file]);

export const resetFilesForUpload = () => filesForUploadVar([]);
